import React from 'react'
import { Row, Container } from 'react-bootstrap';
import './casestudybody24.css';

import clientimg from '../images/case-study-client24.webp'
import outcome from '../images/outcome24.webp'

import sm1 from '../images/cs24so1.webp'
import sm2 from '../images/cs24so2.webp'
import sm3 from '../images/cs24so3.webp'
import sm4 from '../images/cs24so4.webp'
import sm5 from '../images/cs24so5.webp'
import sm6 from '../images/cs24so6.webp'
import sm7 from '../images/cs24so7.webp'
import sm8 from '../images/cs24so8.webp'


const Casestudybody24 = () => {

    return (
        <>
          <section className='casestudybody24-section'  >
          <Container>

            <Row className='w-100 py-md-5 py-4 clintrow'>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <h2>About</h2>
                      {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                      <div className="h1">The Client</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>A London-based boutique private equity firm specializing in investments and deal structuring in mid-scale utilities projects across Europe. Their portfolio spans renewable and non-renewable sectors, including power plant generation and distribution, gas transmission and distribution. </p>
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={clientimg} alt="" />
                </div>
            </Row>
       
            <Row className='mt-md-5'>
              <div className='col-md-12'>
                <div className='content-box'>
                  <h2>Situation</h2>
                  {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                  <div className="h1">Overview</div>
                  <p className='anima '><span className='only-anima-underline' > **** </span></p>
                  <p>The client was evaluating a leveraged buyout opportunity in an European country's gas distribution sector. To support their investment decision in this highly regulated environment, they required a comprehensive understanding of historical and forecasted profit rates as defined by the country's electricity regulator.</p>
                </div>
                
              </div>
            </Row>
          </Container>
        </section>
    
        <section className='casestudybody24-section bg-gredient-dark'>
        <Container>
            <Row>
              <div className='col-md-12'>
                  <div className='content-box'>
                    <h2>Approach &</h2>
                    {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                    <div className="h1">Methodology:</div>
                    <p className='anima '><span className='only-anima-underline' > **** </span></p>
                    <div className='text'>
                            <p>Our team employed a structured and detailed process to meet the client’s specific requirements:</p>
                        </div>
                    
                    <div className='method-stage'> Scoping Workshop</div>
                
                    <div className='list-text my-3'>
                        <div className='icon'>
                        
                        </div>
                        <div className='text'>
                            <p>We initiated the project with an in-depth workshop to clarify objectives, understand the client’s deal structure, and align on how the WACC data would integrate into their valuation models. </p>
                        </div>
                      </div>


                      <div className='method-stage'>Regulatory Framework Research</div>
                
                    <div className='list-text my-3'>
                        <div className='icon'>
                        
                        </div>
                        <div className='text'>
                            <p>Conducted extensive desk-based research on profit rates as defined by the Regulators since its inception in 1997. This included capturing both historical rates and the evolving methodologies prescribed by the regulator. </p>
                        </div>
                      </div>


                      <div className='method-stage'> Forecast Compilation</div>
                
                    <div className='list-text my-3'>
                        <div className='icon'>
                        
                        </div>
                        <div className='text'>
                            <p>Identified and consolidated forecasted WACC values for the period 2024–2028, enabling the client to anticipate market conditions and regulatory shifts. </p>
                        </div>
                      </div>

                      <div className='method-stage'> Precise WACC Calculation</div>
                
                <div className='list-text my-3'>
                    <div className='icon'>
                    
                    </div>
                    <div className='text'>
                        <p>Leveraged the regulator's methodologies, proprietary databases, and reliable public data sources to compute the WACC for each regulatory period between 2008 and 2028. This process ensured accuracy and consistency in forecasting. </p>
                    </div>
                  </div>

                  <div className='method-stage'> Variance Analysis</div>
                
                <div className='list-text my-3'>
                    <div className='icon'>
                    
                    </div>
                    <div className='text'>
                        <p>Prepared a comprehensive variance analysis comparing official regulatory profit rates with our calculated values. This analysis provided insight into historical deviations and informed assumptions for future scenarios.</p>
                    </div>
                  </div>


                  <div className='method-stage'> Industry Benchmarking</div>
                
                <div className='list-text last my-3'>
                    <div className='icon'>
                    
                    </div>
                    <div className='text'>
                        <p>Collated profit rates and computational methodologies from regulatory bodies governing Gas Distribution System Operators (DSOs) across Europe. These benchmarks allowed the client to position their investment against broader industry standards.</p>
                    </div>
                  </div>
                 
                 
             
                      <h3 className='mt-5'>Sample Output</h3>
                      {/* <p><span style={{fontWeight:700}}>Case in Point:</span> We meticulously prepared a comprehensive Portfolio Dashboard and an in-depth Fund Summary. These tools assisted in quickly extracting the performance summary of the fund without much client's involvement.</p> */}
                      <div className='sample-output1 mt-3'>
                        <img src={sm1} alt=''/>
                        <img src={sm2} alt=''/>
                        <img src={sm3} alt=''/>
                        <img src={sm4} alt=''/>
                        <img src={sm5} alt=''/>
                        <img src={sm6} alt=''/>
                        <img src={sm7} alt=''/>
                        <img src={sm8} alt=''/>
                      </div>
            
                  </div>
                  
                </div>
            </Row>
          </Container>
        </section>

    
        <section className='casestudybody24-section outcome'  >
          <Container>
            <Row className='w-100 pb-5 clintrow '>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <div className="h1">Outcome</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>We delivered a structured report that covered historical regulatory profit rates and calculated WACC trends from 2011 to 2028, supported by a detailed variance analysis highlighting deviations between regulatory and calculated rates.<br /><br />The report also included forecasted WACC projections for 2024–2028 with insights into potential regulatory shifts, along with comparative benchmarking data from other European Gas Distribution System Operators. This allowed the client to validate their financial assumptions, refine their investment models, and confidently proceed with technical due diligence for the project.</p>  
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={outcome} alt="" />
                </div>
            </Row>
       
          </Container>
        </section>
    
        </>  
      )
    }

export default Casestudybody24
